import styled from "styled-components";

//TODO: Please remove this file when a css pattern design has been defined.
// Remember it was created to not affect the Input.js component style
// This component only works for VirtualConsultancyCheckout.js inputs.
/**
 */
function Input2({ placeholder, register, ...props }) {
  return (
    <StyledInput
      placeholder={placeholder}
      placeholderTextColor="grey"
      ref={register}
      {...props}
    />
  );
}

const StyledInput = styled.input.attrs((props) => ({
  type: props.type,
}))`
  width: 90%;
  outline: none;
  margin: 1rem 0.5rem;
  background: none;
  border: none;
  border-bottom: 1.25px solid black;
  transition: all 300ms ease 0s;

  &:focus {
    border-bottom: 1.25px solid #fdd440;
    transition: all 300ms ease 0s;
  }
`;

Input2.defaultProps = {};

export default Input2;
